import { TooltipedTextComponent } from 'commons/components';
import { sortAndJoin } from 'commons/utils/sort.utils';
import { PocTypography } from 'commons/components/components-wrapper/poc-typography.component';
import { useTranslation } from 'core/i18n';
import { CustomAlarmActivationMode } from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-custom-alarm-list/components/custom-alarm-activation-confirmation-modal/custom-alarm-active-confirmation-modal.model';
import { getTexts } from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-custom-alarm-list/components/custom-alarm-activation-confirmation-modal/custom-alarm-active-confirmation-modal.business';
import { CustomAlarmListItem } from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-custom-alarm-list/settings-devices-custom-alarm-list.model';
import React from 'react';

export interface CustomAlarmActiveConfirmationModalHeaderComponentProps {
    customAlarms: CustomAlarmListItem[];
    action: CustomAlarmActivationMode;
}

export const CustomAlarmActiveConfirmationModalHeaderComponent: React.FC<
    CustomAlarmActiveConfirmationModalHeaderComponentProps
> = ({ customAlarms, action }) => {
    const { t } = useTranslation();
    const texts = getTexts(customAlarms, action);

    if (customAlarms.length === 1) {
        return (
            <PocTypography variant="button">
                {t(texts.headerText, { name: customAlarms[0].notificationName })}
            </PocTypography>
        );
    }

    return (
        <TooltipedTextComponent
            i18nKey={texts.headerText}
            tooltipText={sortAndJoin(customAlarms.map((alarm) => alarm.notificationName))}
            i18nValues={{ amount: customAlarms.length }}
            tooltipAnchorClassname="blue-tooltip-span"
            showTooltipAlways
        />
    );
};
